/**
 * Converts a string to title case.
 * Replaces hyphens and underscores with spaces, then capitalizes each word.
 * Handles all caps, mixed case, and lowercase text.
 *
 * @param input - The string to convert to title case
 * @returns The title-cased string
 *
 * @example
 * toTitleCase("HELLO_WORLD") // "Hello World"
 * toTitleCase("hello-world") // "Hello World"
 * toTitleCase("hELLo WoRLd") // "Hello World"
 */
export function toTitleCase(input: string): string {
  // Replace hyphens and underscores with spaces
  const cleanedInput = input.replace(/[-_]/g, ' ')

  // Split the string into words, capitalize each word, and join them back together
  const titleCased = cleanedInput
    .split(' ')
    .map((word) => {
      // Handle empty strings
      if (!word) return word
      // Convert entire word to lowercase first, then capitalize first letter
      // This ensures all caps (e.g., "HELLO") becomes "Hello"
      const lowercased = word.toLowerCase()
      return lowercased.charAt(0).toUpperCase() + lowercased.slice(1)
    })
    .join(' ')

  return titleCased
}
